module.exports = __webpack_public_path__ + "img/experience-3-supp.dce13d81.png";